import { render } from "./privacyPolicy.vue?vue&type=template&id=38491cbe&scoped=true"
import script from "./privacyPolicy.vue?vue&type=script&lang=js"
export * from "./privacyPolicy.vue?vue&type=script&lang=js"

import "./privacyPolicy.vue?vue&type=style&index=0&id=38491cbe&scoped=true&lang=css"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38491cbe"]])

export default __exports__